<template lang="pug">
div
  slide(:steps="removeFirst ? 3 : 4")
    h1 Counting eigenvalues
    ul
      li(v-if="!removeFirst", :class="{ grayout: step != 1 }") Elliptic operators
        ul
          li Prerequisite properties
      li(:class="{ grayout: step != (removeFirst ? 1 : 2) }") Courant's nodal domain theorem
        ul
          li Theorem and sketch of proof
      li(:class="{ grayout: step != (removeFirst ? 2 : 3) }") Ixaru's shooting method
        ul
          li Theory and visual demonstration
      li(:class="{ grayout: step != (removeFirst ? 3 : 4) }") A new tool
        ul
          li Theorem and sketch of proof

    p.image-right(v-if="!removeFirst && step == 1", style="bottom: 96px")
      mj(display, style="overflow: auto") -\dv{x}\left[p(x) \dv{u}{x}\right] + q(x) u = \lambda u
      mj(display, style="overflow: auto") -\nabla^2 u + V(\vb{x}) u = \lambda u
    img.image-right(
      v-else-if="step == (removeFirst ? 1 : 2)",
      src="../assets/toc/nodal_domains.svg",
      width="300"
    )
    img.image-right(
      v-else-if="step == (removeFirst ? 2 : 3)",
      src="../assets/toc/ixaru.png",
      style="bottom: 40px"
      width="300"
    )
    img.image-right(
      v-else-if="step == (removeFirst ? 3 : 4)",
      src="../assets/toc/a_new_tool.svg",
      width="280",
      style="right: 50px"
    )

    slide_footer Counting eigenvalues
</template>

<script>
import { Slideshow } from "eagle.js";
import MathJax from "./MathJax.vue";
import Footer from "./Footer.vue";

export default {
  props: { removeFirst: { type: Boolean, default: false } },
  components: {
    slide_footer: Footer,
    mj: MathJax,
  },
  mixins: [Slideshow],
  methods: {
    handleResize() {},
  },
};
</script>